import { Navigate } from 'react-router-dom';

const LifestylePage = () => <Navigate to="/lab/lab_2/maps/lifestyle" replace />;

export default LifestylePage;
